import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

import { computed, inject, onMounted, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { configurationKey } from '@/injections';
import WCProductRowModern from '@/components/WCProductRow/WCProductRowModern.vue';
import WCCouponRowModern from '@/components/WCCouponRow/WCCouponRowModern.vue';
import WCConfiguredProductSectionRows from '@/views/Home/components/WCConfiguredProductSectionRows/WCConfiguredProductSectionRows.vue';
import { ENTRY_METHOD } from '@/models/entities/cart/entry-method';
import usePlatform from '@/modules/platform/composables/usePlatform';


export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const store = useStore();
const { t } = useI18n();
const configuration = inject(configurationKey);
const { platform } = usePlatform();

const overrideCouponRecommendations = ref(false);

const isMobile = computed(() => platform.value.isMobile);

const isGuest = computed(() => store.getters['user/isGuest']);

const showHomepageRecommendations = computed(
  () => configuration?.homepageRecommendationsEnabled && !isGuest.value,
);

const showOnSaleRecommendations = computed(
  () => configuration?.onSaleRecommendationsEnabled && !isGuest.value,
);

const showCouponRecommendations = computed(
  () =>
    configuration?.couponRecommendationsEnabled &&
    configuration?.allowCouponClipping &&
    !overrideCouponRecommendations.value &&
    !isGuest.value,
);

const entryMethodOnSale = ENTRY_METHOD.RECOMMENDATION_ON_SALE;
const entryMethodHomePage = ENTRY_METHOD.RECOMMENDATION_HOME_PAGE;

const setWebAds = (ads: unknown[]) => store.dispatch('browse/setWebAds', ads);

onMounted(() => {
  setWebAds(configuration?.ads);
});

onUnmounted(() => {
  setWebAds([]);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (showOnSaleRecommendations.value)
      ? (_openBlock(), _createBlock(WCProductRowModern, {
          key: 0,
          class: "my-md-3 wc-product-recommendations-rows",
          rowId: 'OSR-9999-9999',
          rowName: _unref(t)('osrRowTitle'),
          isPersonalized: true,
          hideIfEmpty: true,
          entryMethod: _unref(entryMethodOnSale),
          "data-testid": "onSaleRecommendationsRow"
        }, null, 8, ["rowName", "entryMethod"]))
      : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createTextVNode()),
    (showHomepageRecommendations.value)
      ? (_openBlock(), _createBlock(WCProductRowModern, {
          key: 1,
          class: "my-md-3 wc-product-recommendations-rows",
          rowId: 'HPR-9999-9999',
          rowName: _unref(t)('hprRowTitle'),
          isPersonalized: true,
          hideIfEmpty: true,
          entryMethod: _unref(entryMethodHomePage),
          "data-testid": "homepageRecommendationsRow"
        }, null, 8, ["rowName", "entryMethod"]))
      : _createCommentVNode("", true),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createElementVNode("div", {
      class: _normalizeClass({ 'wc-coupon-recommendations-rows-desktop': !isMobile.value })
    }, [
      (showCouponRecommendations.value)
        ? (_openBlock(), _createBlock(WCCouponRowModern, {
            key: 0,
            class: "my-md-3",
            useRecs: true,
            isPersonalized: true,
            onNoRecs: _cache[0] || (_cache[0] = ($event: any) => (overrideCouponRecommendations.value = true)),
            "data-testid": "homepageCouponRecommendationsRow"
          }))
        : _createCommentVNode("", true)
    ], 2),
    _cache[3] || (_cache[3] = _createTextVNode()),
    _createVNode(WCConfiguredProductSectionRows, {
      name: _ctx.$configuration.store.name,
      rows: _ctx.$configuration.rows,
      hideCoupons: showCouponRecommendations.value
    }, null, 8, ["name", "rows", "hideCoupons"])
  ]))
}
}

})